module.exports = __webpack_public_path__ + "static/media/bailey.fc4c5794.jpg";